"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3970],{

/***/ 354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "MM": function() { return /* binding */ listingRearranger; },
/* harmony export */   "eS": function() { return /* binding */ contentRearranger; }
/* harmony export */ });
function contentRearranger(param) {
    var content = param.content, _useTruvid = param.useTruvid, useTruvid = _useTruvid === void 0 ? true : _useTruvid, _useMembrana = param.useMembrana, useMembrana = _useMembrana === void 0 ? false : _useMembrana, _adsOptions = param.adsOptions, adsOptions = _adsOptions === void 0 ? {
        enableMobile: true,
        enableDesktop: true,
        positionMobile: 4,
        positionDesktop: 4
    } : _adsOptions, _truvidOptions = param.truvidOptions, truvidOptions = _truvidOptions === void 0 ? {
        enableMobile: true,
        enableDesktop: true,
        positionMobile: 1,
        positionDesktop: 2
    } : _truvidOptions, _membranaOptions = param.membranaOptions, membranaOptions = _membranaOptions === void 0 ? {
        enableMobile: true,
        enableDesktop: true,
        positionMobile: 1,
        positionDesktop: 2
    } : _membranaOptions, _shouldUseIdCountPosition = param.shouldUseIdCountPosition, shouldUseIdCountPosition = _shouldUseIdCountPosition === void 0 ? true : _shouldUseIdCountPosition;
    var length = content === null || content === void 0 ? void 0 : content.length;
    var maxIdCountPosition = 10;
    if (length < adsOptions.positionMobile && length < adsOptions.positionDesktop) return content;
    var isValidDesktop = function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : +1;
        return i % adsOptions.positionDesktop === 0 && i >= adsOptions.positionDesktop && i < length && adsOptions.enableDesktop;
    };
    var isValidMobile = function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : +1;
        return i % adsOptions.positionMobile === 0 && i >= adsOptions.positionMobile && i < length && adsOptions.enableMobile;
    };
    var shouldRenderTruvidMobile = function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : +1;
        return useTruvid && truvidOptions.enableMobile && i === adsOptions.positionMobile * truvidOptions.positionMobile;
    };
    var shouldRenderMembranaMobile = function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : +1;
        return useMembrana && membranaOptions.enableMobile && i === adsOptions.positionMobile * membranaOptions.positionMobile;
    };
    var shouldRenderTruvidDesktop = function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : +1;
        return useTruvid && truvidOptions.enableDesktop && i === adsOptions.positionDesktop * truvidOptions.positionDesktop;
    };
    var shouldRenderMembranaDesktop = function() {
        var i = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : +1;
        return useMembrana && membranaOptions.enableDesktop && i === adsOptions.positionDesktop * membranaOptions.positionDesktop;
    };
    var contentRearranged = [];
    var adMobileCount = 1;
    var adDesktopCount = 1;
    var adTruvidM = {
        tipo: "adTruvidMobile"
    };
    var adTruvidD = {
        tipo: "adTruvidDesktop"
    };
    var adMembranaM = {
        tipo: "adMembranaMobile"
    };
    var adMembranaD = {
        tipo: "adMembranaDesktop"
    };
    content.forEach(function(block, i) {
        var adMobile = {
            tipo: "adMobile",
            idCountPosition: shouldUseIdCountPosition && adMobileCount <= maxIdCountPosition ? adMobileCount.toString() : ""
        };
        var adDesktop = {
            tipo: "adDesktop",
            idCountPosition: shouldUseIdCountPosition && adDesktopCount <= maxIdCountPosition ? adDesktopCount.toString() : ""
        };
        if (content.length >= 4 && i === 4) {
            contentRearranged.push({
                tipo: "cardCTA"
            });
        }
        if (i === 0) {
            contentRearranged.push(adMobile);
            adMobileCount += 1;
        }
        if (isValidMobile(i) && shouldRenderTruvidMobile(i) && !shouldRenderMembranaMobile(i)) contentRearranged.push(adTruvidM);
        if (isValidMobile(i) && shouldRenderMembranaMobile(i) && !shouldRenderTruvidMobile(i)) contentRearranged.push(adMembranaM);
        if (isValidMobile(i) && !shouldRenderTruvidMobile(i) && !shouldRenderMembranaMobile(i)) {
            if (adMobileCount <= maxIdCountPosition) contentRearranged.push(adMobile);
            if (adMobileCount <= maxIdCountPosition) adMobileCount += 1;
        }
        if (isValidDesktop(i) && shouldRenderTruvidDesktop(i) && !shouldRenderMembranaDesktop(i)) contentRearranged.push(adTruvidD);
        if (isValidDesktop(i) && shouldRenderMembranaDesktop(i) && !shouldRenderTruvidDesktop(i)) contentRearranged.push(adMembranaD);
        if (isValidDesktop(i) && !shouldRenderTruvidDesktop(i) && !shouldRenderMembranaDesktop(i)) {
            if (adDesktopCount <= maxIdCountPosition) contentRearranged.push(adDesktop);
            if (adDesktopCount <= maxIdCountPosition) adDesktopCount += 1;
        }
        contentRearranged.push(block);
        if (content.length > 9 && i === 8) {
            contentRearranged.push({
                tipo: "readMore"
            });
        }
    });
    return contentRearranged;
}
var adsContainsMobile = {
    ads: true,
    mobile: true
};
var adsContainsDesktop = {
    ads: true,
    mobile: false
};
function listingRearranger(param) {
    var content = param.content, primary = param.primary, _hasNoAds = param.hasNoAds, hasNoAds = _hasNoAds === void 0 ? false : _hasNoAds, _sizeMobile = param.sizeMobile, sizeMobile = _sizeMobile === void 0 ? 3 : _sizeMobile, _sizeDesktop = param.sizeDesktop, sizeDesktop = _sizeDesktop === void 0 ? 6 : _sizeDesktop;
    var length = content === null || content === void 0 ? void 0 : content.length;
    var result = [];
    if (!primary) {
        result.push(adsContainsDesktop);
    }
    var chunkified = [];
    content.forEach(function(element, index) {
        chunkified.push(element);
        if ((index + 1) % sizeMobile === 0 && index + 1 >= sizeMobile && !hasNoAds) chunkified.push(adsContainsMobile);
        if ((index + 1) % sizeDesktop === 0 && index + 1 >= sizeDesktop) {
            result.push({
                chunck: chunkified
            });
            if (index + 1 < length && !hasNoAds) result.push(adsContainsDesktop);
            chunkified = [];
        }
        if (chunkified.length > 0 && length === index + 1) {
            result.push({
                chunck: chunkified
            });
        }
    });
    return result;
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
    contentRearranger: contentRearranger,
    listingRearranger: listingRearranger
});


/***/ }),

/***/ 2155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ SponseredCategoryHeader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _lib_sponsors__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6874);
/* harmony import */ var _utils_className__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9659);



var SponseredCategoryHeader = function(param) {
    var sponsoredCategory = param.sponsoredCategory, _logoSize = param.logoSize, logoSize = _logoSize === void 0 ? undefined : _logoSize;
    var sponsorData = _lib_sponsors__WEBPACK_IMPORTED_MODULE_1__/* .sponsorCategoryData */ .Bw[sponsoredCategory];
    if (!sponsorData) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mb-4 flex flex-col items-end justify-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "mb-1 text-[10px] font-light text-mglGray500",
                children: "Conte\xfado apoiado por"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-row gap-2",
                children: sponsorData.map(function(sponsor, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        className: (0,_utils_className__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex flex-row items-center"),
                        href: sponsor.url,
                        rel: "sponsored",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            title: sponsor.title,
                            src: sponsor.image.desktop.src,
                            height: sponsor.image.desktop.height,
                            width: sponsor.image.desktop.width,
                            alt: sponsor.title
                        })
                    }, "".concat(index));
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                className: "mt-4 w-full border-t border-mglGray100 border-opacity-20"
            })
        ]
    });
};


/***/ }),

/***/ 6874:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ sponsorCategoryData; },
/* harmony export */   "P2": function() { return /* binding */ enableSponsoredCategories; },
/* harmony export */   "PV": function() { return /* binding */ getEditorialCategory; },
/* harmony export */   "Rt": function() { return /* binding */ getSponsoredCategory; },
/* harmony export */   "SU": function() { return /* binding */ getSponsoredCategoryOrTypeWithStringToInternal; },
/* harmony export */   "b3": function() { return /* binding */ getEditorialCategoryWithStringToInternal; },
/* harmony export */   "xu": function() { return /* binding */ isSponsoredOrEditorialToInternal; }
/* harmony export */ });
/* unused harmony export sponsoredCategoriesTutorialsUri */
var sponsorCategoryData = {
    tutoriais: [
        {
            url: "https://www.kaspersky.com.br/premium?reseller=br_eg-mf_acq_ona_dis__onl_b2c_canaltech_ban_______&utm_content=banner%7Cgeneric&utm_source=canaltech&utm_medium=display&utm_term=youtube&utm_campaign=",
            title: "Ir para o site do Kaspersky!",
            image: {
                mobile: {
                    src: "https://t.ctcdn.com.br/FnVpzZ0gZiMg1_u-Eskkk_76vHo=/i990769.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 80
                },
                desktop: {
                    src: "https://t.ctcdn.com.br/FnVpzZ0gZiMg1_u-Eskkk_76vHo=/i990769.png",
                    blurhash: "LTS6Plt7%Mt7xufQfQay~qofIUof",
                    height: 30,
                    width: 80
                }
            }
        }, 
    ]
};
var enableSponsoredCategories = [
    "tutoriais"
];
var sponsoredCategoriesTutorialsUri = [
    "tutoriais"
];
var editorialCategoriesCtupUri = [
    "hardware",
    "games",
    "ctup",
    "notebook"
];
var sponsoredCategoriesTutorialsTitle = [
    "Tutoriais"
];
var sponsoredpublicationType = [
    "4"
];
var editorialCategoriesCtupTitle = [
    "Hardware",
    "Games",
    "Notebook"
];
var editorialCategoriesCtAutoTitle = [
    "Ve\xedculos",
    "Carros",
    "Mobilidade Urbana",
    "Ve\xedculos Aut\xf4nomos"
];
var getSponsoredCategory = function(singleCategory) {
    if (sponsoredCategoriesTutorialsUri.includes(singleCategory)) return "tutoriais";
    return undefined;
};
var getEditorialCategory = function(singleCategory) {
    if (editorialCategoriesCtupUri.includes(singleCategory)) return "ctup";
    if (singleCategory === "eletro") return "eletro";
    if (singleCategory === "ctauto") return "ctauto";
    return undefined;
};
var isSponsoredOrEditorialToInternal = function(mainCategory, categories) {
    var publicationType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "1";
    if (sponsoredCategoriesTutorialsTitle.includes(mainCategory)) return "sponsored";
    if (editorialCategoriesCtupTitle.includes(mainCategory)) return "editorial";
    if (editorialCategoriesCtAutoTitle.includes(mainCategory)) return "editorial";
    if (mainCategory === "CT Eletro") return "editorial";
    if (categories.some(function(categoria) {
        return sponsoredCategoriesTutorialsTitle.includes(categoria);
    })) return "sponsored";
    if (sponsoredpublicationType.includes(publicationType)) return "sponsored";
    if (categories.some(function(categoria) {
        return editorialCategoriesCtupTitle.includes(categoria);
    })) return "editorial";
    if (categories.some(function(categoria) {
        return editorialCategoriesCtAutoTitle.includes(categoria);
    })) return "editorial";
    if (categories.includes("CT Eletro")) return "editorial";
    return undefined;
};
var getSponsoredCategoryOrTypeWithStringToInternal = function(categories, mainCategory) {
    var publicationType = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "1";
    var category = undefined;
    if (mainCategory && sponsoredCategoriesTutorialsTitle.includes(mainCategory)) category = "tutoriais";
    if (sponsoredpublicationType.includes(publicationType)) category = "tutoriais";
    if (categories.some(function(categoria) {
        return sponsoredCategoriesTutorialsTitle.includes(categoria);
    })) category = "tutoriais";
    if (!enableSponsoredCategories.includes(category)) return undefined;
    return category;
};
var getEditorialCategoryWithStringToInternal = function(categories, mainCategory) {
    var category = undefined;
    if (categories.some(function(categoria) {
        return editorialCategoriesCtupTitle.includes(categoria);
    })) category = "ctup";
    if (categories.some(function(categoria) {
        return editorialCategoriesCtAutoTitle.includes(categoria);
    })) category = "ctauto";
    if (categories.includes("CT Eletro")) category = "eletro";
    if (editorialCategoriesCtupTitle.includes(mainCategory)) category = "ctup";
    if (editorialCategoriesCtAutoTitle.includes(mainCategory)) category = "ctauto";
    if (mainCategory === "CT Eletro") category = "eletro";
    return category;
};


/***/ }),

/***/ 8469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ny": function() { return /* binding */ mimir; },
/* harmony export */   "hi": function() { return /* binding */ api; }
/* harmony export */ });
/* unused harmony exports site, validatesResponse, guia */
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios_retry__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8662);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_2__);



var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_2___default()().publicRuntimeConfig;
var api = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "".concat(publicRuntimeConfig.NEXT_PUBLIC_API_BASE, "/api"),
    timeout: 10000,
    responseType: "json"
});
var site = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: "".concat(publicRuntimeConfig.NEXT_PUBLIC_API_BASE, "/").concat(publicRuntimeConfig.NEXT_PUBLIC_API_VERSION),
    timeout: 10000,
    responseType: "json"
});
var mimir = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: publicRuntimeConfig.NEXT_PUBLIC_API_MIMIR,
    timeout: 10000,
    responseType: "json"
});
var guia = axios__WEBPACK_IMPORTED_MODULE_0___default().create({
    baseURL: publicRuntimeConfig.NEXT_PUBLIC_API_GUIA,
    timeout: 10000,
    responseType: "json"
});
api.interceptors.request.use(function(config) {
    config.url = encodeURI(config.url);
    return config;
});
site.interceptors.request.use(function(config) {
    config.url = encodeURI(config.url);
    return config;
});
// 408 Request Timeout,
// 500 Internal Server Error,
// 502 Bad Gateway,
// 503 Service Unavailable ,
// 504 Gateway Timeout
// Se ECONNABORTED, vem do timeOut do Axios
// Se isNetworkOrIdempotentRequestError validado pelo axiosRetry
(0,axios_retry__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(api, {
    retries: 5,
    shouldResetTimeout: true,
    retryDelay: axios_retry__WEBPACK_IMPORTED_MODULE_1__/* ["default"].exponentialDelay */ .ZP.exponentialDelay,
    retryCondition: function(error) {
        var ref, ref1, ref2, ref3, ref4;
        return ((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === 408 || ((ref1 = error.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 500 || ((ref2 = error.response) === null || ref2 === void 0 ? void 0 : ref2.status) === 502 || ((ref3 = error.response) === null || ref3 === void 0 ? void 0 : ref3.status) === 503 || ((ref4 = error.response) === null || ref4 === void 0 ? void 0 : ref4.status) === 504 || error.code === "ECONNABORTED" || axios_retry__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isNetworkOrIdempotentRequestError */ .ZP.isNetworkOrIdempotentRequestError(error);
    }
});
(0,axios_retry__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(site, {
    retries: 5,
    shouldResetTimeout: true,
    retryDelay: axios_retry__WEBPACK_IMPORTED_MODULE_1__/* ["default"].exponentialDelay */ .ZP.exponentialDelay,
    retryCondition: function(error) {
        var ref, ref1, ref2, ref3, ref4;
        return ((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === 408 || ((ref1 = error.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 500 || ((ref2 = error.response) === null || ref2 === void 0 ? void 0 : ref2.status) === 502 || ((ref3 = error.response) === null || ref3 === void 0 ? void 0 : ref3.status) === 503 || ((ref4 = error.response) === null || ref4 === void 0 ? void 0 : ref4.status) === 504 || error.code === "ECONNABORTED" || axios_retry__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isNetworkOrIdempotentRequestError */ .ZP.isNetworkOrIdempotentRequestError(error);
    }
});
(0,axios_retry__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(mimir, {
    retries: 5,
    shouldResetTimeout: true,
    retryDelay: axios_retry__WEBPACK_IMPORTED_MODULE_1__/* ["default"].exponentialDelay */ .ZP.exponentialDelay,
    retryCondition: function(error) {
        var ref, ref1, ref2, ref3, ref4;
        return ((ref = error.response) === null || ref === void 0 ? void 0 : ref.status) === 408 || ((ref1 = error.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 500 || ((ref2 = error.response) === null || ref2 === void 0 ? void 0 : ref2.status) === 502 || ((ref3 = error.response) === null || ref3 === void 0 ? void 0 : ref3.status) === 503 || ((ref4 = error.response) === null || ref4 === void 0 ? void 0 : ref4.status) === 504 || error.code === "ECONNABORTED" || axios_retry__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isNetworkOrIdempotentRequestError */ .ZP.isNetworkOrIdempotentRequestError(error);
    }
});
var validatesResponse = function(dataResponseAPI) {
    var isCatch = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, isCategory = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, category = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", host = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, prevHost = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, pathName = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : null;
    var ref, ref1, ref2, ref3;
    // Usando o CT status que são:
    // case 0: //sucesso(200)
    // case 1: //erro no servidor(500)
    // case 2: //acesso negado(403)
    // case 3: //não encontrado(404)
    // case 4: //inconsistencia(400)
    // case 5: //metodo não permitido(405)
    // case 6: //redirect(301)
    // case 7: //redirect(301)
    var data = null;
    var statusCode = 0;
    if (!isCatch && dataResponseAPI) {
        data = dataResponseAPI.data;
        statusCode = dataResponseAPI.status;
        if ((data === null || data === void 0 ? void 0 : data.status) == null) {
            return {
                data: data,
                statusCode: statusCode
            };
        }
    }
    switch(isCatch ? (ref = dataResponseAPI.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.status : dataResponseAPI.data.status){
        case 3:
            if (!isCategory) {
                data = {
                    notFound: true,
                    props: {}
                };
            } else {
                data = {
                    redirect: {
                        statusCode: 301,
                        destination: "".concat(publicRuntimeConfig.NEXT_PUBLIC_URL, "/").concat(category, "/")
                    },
                    props: {}
                };
            }
            break;
        case 8:
            return {
                data: {
                    headers: isCatch ? dataResponseAPI.response.data.headers : data.headers
                },
                statusCode: isCatch ? dataResponseAPI.response.data.data.codigo : data.data.codigo
            };
            break;
        case 1:
        case 2:
        case 4:
        case 5:
            statusCode = isCatch ? dataResponseAPI.response.data.data.codigo : data.data.codigo;
            break;
        case 6:
        case 7:
            data = {
                redirect: {
                    statusCode: isCatch ? dataResponseAPI.response.data.data.codigo : data.data.codigo,
                    destination: isCatch ? dataResponseAPI.response.data.data.url : data.data.url
                },
                props: {}
            };
            break;
        default:
            if (isCatch) throw dataResponseAPI;
            statusCode = dataResponseAPI.status;
    }
    var desiredHost = (dataResponseAPI === null || dataResponseAPI === void 0 ? void 0 : (ref2 = dataResponseAPI.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.data) === null || ref3 === void 0 ? void 0 : ref3.dominio) || publicRuntimeConfig.NEXT_PUBLIC_HOST;
    if ((host === null || host === void 0 ? void 0 : host.toString()) !== (desiredHost === null || desiredHost === void 0 ? void 0 : desiredHost.toString())) {
        var ref4, ref5;
        data = {
            redirect: {
                statusCode: 301,
                destination: "https://".concat(desiredHost).concat((dataResponseAPI === null || dataResponseAPI === void 0 ? void 0 : (ref4 = dataResponseAPI.data) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.data) === null || ref5 === void 0 ? void 0 : ref5.url) || pathName || "")
            },
            props: {}
        };
    }
    return {
        data: data,
        statusCode: statusCode
    };
};



/***/ })

}]);